import React, { useState } from 'react';
import { Box, Container, Text, VStack } from '@chakra-ui/react';
import NavBar from '../../../Components/Navbar/NavBar';
import Sales from "./SalesSBC";
import Reports from "./ReportsSBC";
import About from './AboutSBC';
import sbc_logo from '../../../Assets/sbc_logo.png';

function SBC() {
    const [selectedOption, setSelectedOption] = useState('Sales');
    
    const handleTabClick = (tab) => {
        setSelectedOption(tab);
    };

    const renderContent = () => {
        switch (selectedOption) {
            case 'Sales':
                return <Sales content="Sales SBC" color="red" />;
            case 'Reports':
                return <Reports content="Reports SBC" />;
            case 'About':
                return <About content="About SBC" />;
            default:
                return <Sales content="Sales SBC" color="red" />;
        }
    };

    return (
        <Box h="100vh" bg="gray.50" overflow="hidden">
            <NavBar 
                tabIndicatorColor="red.500" 
                logo={sbc_logo} 
                onTabClick={handleTabClick} 
            />
            
            <Box bg="white" w="100%" h="calc(100vh - 60px)" overflow="hidden">
                {renderContent()}
            </Box>
        </Box>
    );
}

export default SBC;
